import { HeaderWrapper, LogoContainer, NavItem } from "./styles";
import logoImg from "../../assets/images/logo.png";

export default function Header() {
  return (
    <HeaderWrapper>
      <div className="max-w-7xl mx-auto flex items-center h-full justify-between">
        <a
          href="/app/dashboard"
          >
          <LogoContainer>
            <img src={logoImg} alt="Header Logo" />
          </LogoContainer>
        </a>

        <div className="flex items-center gap-4 pr-2">

          <a
            href="https://downiewenjack.ca/"
            target="_blank"
            rel="noopener noreferrer"
          >  
          <NavItem>DWF Main Website</NavItem>
          </a>
          
          <div className="h-4 w-px bg-gray-600"></div>

          <a 
            href="https://downiewenjack.ca/mental-health-resources/"
            target="_blank"
            rel="noopener noreferrer"
            >
            <NavItem>Mental Health Resources</NavItem>
          </a>

          <div className="h-4 w-px bg-gray-600"></div>

          <a 
            href="https://downiewenjack.ca/news-publications/subscribe/"
            target="_blank"
            rel="noopener noreferrer"
            >
            <NavItem>Subscribe</NavItem>
          </a>

          <div className="h-4 w-px bg-gray-600"></div>

          <a 
            href="https://downiewenjack.ca/our-work/legacy-schools-programs/hub-quick-start/"
            target="_blank"
            rel="noopener noreferrer"
            >
            <NavItem>Help</NavItem>
          </a>
        </div>
      </div>
    </HeaderWrapper>
  )
}
